<template>
  <div class="Login Login--accept-invitation-block Login--self-onboarding background-blue d-flex flex-column justify-content-center align-items-center w-100 h-100">
    <div class="signup-box">
      <div class="d-flex flex-row w-100">

        <div class="Login-logo mx-auto">
          <img
            alt="Fuell logo"
            :src="require('@/assets/img/logo.svg')"
          >
        </div>
      </div>
      <div class="d-flex justify-content-center w-100">
        <spinner v-if="isActivating" />
        <div
          class="activation-box"
          v-if="!isActivating"
        >
          <div
            class="d-flex flex-column align-items-center"
            v-if="activationSuccess"
          >
            <img
              :src="require('@/assets/img/animations/fuell-success-animated-icon.gif')"
              alt="OK"
            >
            <h1 class="Tit Tit--login my-3 text-center">
              {{$t('user_self_onboarding_activation_success')}}
            </h1>
            <i18n
              tag="small"
              class="Fuell-Text small"
              path="user_self_onboarding_activation_success_redirection"
            >
              <template v-slot:click>
                <span
                  class="text-primary clickable"
                  @click="$router.push({name:'dashboard'})"
                >{{$t('ACTION_CLICK_HERE')}}</span>
              </template>
            </i18n>

          </div>
          <div
            class="d-flex flex-column align-items-center"
            v-else
          >
            <img
              :src="require('@/assets/img/icons/payment-failed.svg')"
              alt="KO"
            >
            <h1 class="Tit Tit--login my-3 text-center">
              {{$t('user_self_onboarding_activation_failure')}}
            </h1>
            <i18n
              tag="p"
              class="Fuell-Text"
              path="user_self_onboarding_activation_failure_contact_support"
            >
              <template v-slot:customerSupport>
                <span
                  class="text-primary clickable"
                  @click="openSupport"
                > {{$t('dashboard_card_payment_failed_support')}}</span>
              </template>
            </i18n>
            <small
              class="Fuell-Text text-primary clickable"
              @click="$router.push({name:'login'})"
            >{{$t('ACTION_RETURN_TO_LOGIN')}}</small>
          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'
export default {
  name: 'ActivateCustomer',
  components: { Spinner },
  data () {
    return {
      isActivating: false,
      activationSuccess: false
    }
  },
  methods: {
    async activateCustomer () {
      if (this.isActivating) return
      try {
        this.isActivating = true
        await this.$store.dispatch('LoginStore/acceptInvitation', { invitationData: { token: this.$route.params.token }, selfOnboarding: true })
        this.isActivating = false
        this.activationSuccess = true
        setTimeout(() => {
          this.$router.push({ name: 'dashboard' })
        }, 5000)
      } catch (error) {
        this.activationSuccess = false
        this.isActivating = false
      }
    },
    async openSupport () {
      let errorMessage = this.$t('user_self_onboarding_activation_failure_message')
      if (window.HubSpotConversations?.widget?.open) {
        window.HubSpotConversations.widget.open(errorMessage)
      }
    }
  },
  created () {
    if (!this.$route.params.token) {
      this.$router.push({ name: 'login' })
    } else {
      this.activateCustomer()
    }
  }

}
</script>

<style scoped>
.background-blue {
  background-color: var(--semantic-brand-main);
}
.signup-box {
  border-radius: 4px;
  background-color: var(--fill-main-background) !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 438px;
  max-height: 666px;
  padding: 0px 48px 20px 48px;
}
.Tit--login {
  margin: 40px 0px;
  line-height: 32px;
}
.Login-logo {
  margin-top: 40px;
  margin-bottom: 30px;
}
.Fuell-Text {
  font-weight: 400;
}
.small {
  font-size: 12px;
}
.Invitation-form {
  justify-content: unset;
}
.Login--self-onboarding {
  background-image: url("~@/assets/img/signup-background.png");
  background-position: center center;
  background-size: cover;
}
</style>
